<template>
  <CCard class="weight-history-chart">
    <CCardBody>
      <div class="weight-history-chart__header">
        <div>
          <div class="weight-history-chart__eyebrow">Trend tezine</div>
          <h3 class="weight-history-chart__title">{{ selectedResolution.chartSubTitle }}</h3>
        </div>
        <div class="weight-history-chart__metric">
          <span class="weight-history-chart__metric-label">Zadnji prosjek</span>
          <strong>{{ latestAverage }}</strong>
        </div>
      </div>
      <div class="weight-history-chart__canvas">
        <CChartBar class="weight-history-chart__canvas-element" :datasets="chartData" :options="chartOptions" :labels="chartLabels" />
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import { CChartBar } from "@coreui/vue-chartjs";
import { getWeightTrendColors } from "@/weightChartColors";

const chartValues = (averages) =>
  averages.map((entry) => {
    if (entry.value === null || entry.value === undefined || entry.value === "") {
      return null;
    }

    return Number(entry.value);
  });

export default {
  components: { CChartBar },

  props: {
    averages: {
      type: Array,
      default: () => [],
    },
    selectedResolution: {
      type: Object,
      required: true,
    },
  },

  computed: {
    latestAverage() {
      const values = chartValues(this.averages).filter((value) => Number.isFinite(value));
      if (!values.length) {
        return "-";
      }

      return `${values[values.length - 1].toFixed(1)} kg`;
    },
    chartLabels() {
      return this.averages.map((entry) => entry.key);
    },
    chartData() {
      const values = chartValues(this.averages);
      return [
        {
          label: this.selectedResolution.chartSubTitle,
          data: values,
          backgroundColor: getWeightTrendColors(values),
          borderRadius: 6,
          barPercentage: 0.72,
          categoryPercentage: 0.74,
        },
      ];
    },
    chartOptions() {
      return {
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: {
          mode: "index",
          intersect: false,
          backgroundColor: "#0f172a",
          titleFontColor: "#f8fafc",
          bodyFontColor: "#e2e8f0",
          displayColors: false,
          xPadding: 12,
          yPadding: 10,
          callbacks: {
            label: (tooltipItem) => `${tooltipItem.value} kg`,
          },
        },
        scales: {
          xAxes: [
            {
              gridLines: {
                display: false,
                drawBorder: false,
              },
              ticks: {
                fontColor: "#94a3b8",
                maxTicksLimit: 8,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                color: "#e8eef5",
                drawBorder: false,
              },
              ticks: {
                fontColor: "#94a3b8",
                maxTicksLimit: 6,
                padding: 10,
                callback: (value) => `${value} kg`,
              },
            },
          ],
        },
      };
    },
  },
};
</script>

<style scoped>
.weight-history-chart {
  height: 100%;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  box-shadow: none;
}

.weight-history-chart .card-body {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 380px;
  padding: 1.5rem;
}

.weight-history-chart__canvas {
  position: relative;
  flex: 0 0 auto;
  height: clamp(240px, 30vh, 300px);
  width: 100%;
  min-width: 0;
  overflow: hidden;
}

.weight-history-chart__canvas-element {
  height: 100%;
  width: 100%;
  min-width: 0;
}

.weight-history-chart__canvas-element /deep/ canvas {
  height: 100% !important;
  width: 100% !important;
  max-width: 100%;
  display: block;
}

.weight-history-chart__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.weight-history-chart__eyebrow {
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.weight-history-chart__title {
  margin: 0.35rem 0 0;
  color: #0f172a;
  font-size: 1.25rem;
  font-weight: 700;
}

.weight-history-chart__metric {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: #0f172a;
}

.weight-history-chart__metric-label {
  color: #64748b;
  font-size: 0.8rem;
  font-weight: 600;
}

.weight-history-chart__metric strong {
  font-size: 1.35rem;
  line-height: 1.2;
}

@media (max-width: 767px) {
  .weight-history-chart {
    border-radius: 14px;
  }

  .weight-history-chart .card-body {
    min-height: 340px;
    padding: 1rem;
  }

  .weight-history-chart__canvas {
    height: 220px;
  }

  .weight-history-chart__header {
    margin-bottom: 1rem;
  }

  .weight-history-chart__title {
    font-size: 1.05rem;
  }

  .weight-history-chart__metric strong {
    font-size: 1.1rem;
  }
}
</style>
